import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup';
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import SearchIcon from '@material-ui/icons/Search'
import Typography from '@material-ui/core/Typography';
import TableContextMenuFilterComponent from './TableContextMenuFilterComponent'
import ExcelExportDisabled from '../../assets/img/ExcelExportDisabled.svg'
import excelIcon from '../../assets/img/ExcelIcon.svg'
const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    height: '32px',
    width: '32px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    color: '#7A9BC2',
    border: '1px solid #7A9BC2'
}

const searchInput = {
    border: '1px solid #7A9BC2',
    background: 'white',
    borderRadius: '0px',
    width: '175px',
    height: '32px',
    fontSize: '14px',
    textTransform: "initial"
}

const IconStyle = {
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
    borderTopRightRadius: '0px',
    borderBottomRightRadius: '0px',
    height: '32px',
    minWidth: '10px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'white',
    border: '1px solid #7A9BC2'
}

const TableFilterComponentOtherTransactions = ({ filterText, onFilter, name, styles,
    allowFilter, allowTextFilter, module, SendToFilter, ClearFiltered, onClear,
    toolTipText, SearchFilter, SearchButton, ordersFilterData, handleSearchMultipleBoxChange, setOrdersFilterData, hasFilter, 
    allowUploadOrders, allowDownload, onExport, ...props }) => {
    const { t } = useTranslation();

    return (
        <Grid container >
            <Grid item xs={12} sm={module == 'orders' ? 12 : 7}>
                {module == 'orders' &&
                    <h5 style={{ color: '#FFFFFF', paddingTop: '5px' }}> {name}</h5>
                }
                {module == 'OrderDetailInfoGeneral' &&
                    <Typography variant="body2" style={{ color: "#fff", paddingTop: "0.4em" }}>{t("OrderDetailDashboard.AccordionServiceDetail")}</Typography>
                }
                {module == 'OrderDetailComments' &&
                    <Typography variant="body2" style={{ color: "#fff", paddingTop: "0.4em" }}>{t("OrderDetailDashboard.AccordionComments")}</Typography>
                }
            </Grid>
            <Grid item xs={12} sm={module == 'orders' ? 12 : 5} className={styles}>
                <ButtonGroup disableElevation variant="contained">
                    {
                        allowTextFilter && (
                            <TextField id="search" type="text" placeholder={t('TableOrder.search')} maxLength={100} aria-label="Search Input" value={filterText} style={searchInput} onChange={onFilter} title={toolTipText} />
                        )
                    }
                    {
                        allowTextFilter && SearchButton === 'Visible' && (
                            <Button type="button" variant="contained" onClick={SearchFilter} color="primary" title={t('common.search')} style={ClearButton}><SearchIcon /></Button>
                        )
                    }
                    {
                        allowTextFilter && (
                            <Button type="button" variant="contained" onClick={onClear} color="primary" title={t('common.clear')} style={ClearButton}><b>X</b></Button>
                        )
                    }
                    {
                        allowFilter && (
                            <TableContextMenuFilterComponent
                                IconStyle={IconStyle}
                                Module={module}
                                SendToFilter={SendToFilter}
                                ClearFiltered={ClearFiltered}
                                ordersFilterData={ordersFilterData}
                                setOrdersFilterData={setOrdersFilterData}
                                handleSearchMultipleBoxChange={handleSearchMultipleBoxChange}
                                t={t}
                                hasFilter={hasFilter}
                            />
                        )
                    }
                    {
                        allowUploadOrders && (
                            <Button type="button" variant="outlined" onClick={e => onExport(e.target.value)} style={ClearButton} title={t('TableOrder.downloadExcelToolTips')}
                                disabled={allowDownload}
                            >
                                <img src={allowDownload ? ExcelExportDisabled : excelIcon} alt="excel-icon" width="24" height="24" />
                            </Button>
                        )
                    }

                </ButtonGroup>
            </Grid>
        </Grid>
    )
}

export default TableFilterComponentOtherTransactions
